import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { AngularEditorConfig } from '@kolkov/angular-editor';

@Component({
	selector: 'app-modal-generar-ayuda',
	templateUrl: './modal-generar-ayuda.component.html',
	styleUrls: ['./modal-generar-ayuda.component.scss']
})
export class ModalGenerarAyudaComponent implements OnInit {
	@Input()
	texto_ayuda: string;
	@Input()
	editable = true;
	formControl: FormControl;

	public config: AngularEditorConfig = {
		editable: true,
		spellcheck: true,
		height: '15rem',
		minHeight: '5rem',
		placeholder: 'Insertar texto de ayuda',
		translate: 'no',
		customClasses: [
		]
	};

	constructor(private activeModal: NgbActiveModal, private formBuilder: FormBuilder) {
		this.formControl = formBuilder.control('', Validators.required);
	}

	ngOnInit() {
		this.formControl.patchValue(this.texto_ayuda);
		this.config.editable = this.editable;
	}

	confirm(): void {
		if (this.activeModal) {
			this.activeModal.close(this.formControl.value);
		}
	}

	onDismiss(): void {
		if (this.activeModal) {
			this.activeModal.dismiss();
		}
	}
}
